var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPayChargeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 74 74",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.0000934601,
    width: 74,
    height: 74,
    rx: 4,
    fill: "#76BC45"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2119 19.3787C15.3332 20.2574 15.3332 21.6716 15.3332 24.5V51.5C15.3332 54.3284 15.3332 55.7426 16.2119 56.6213C17.0906 57.5 18.5048 57.5 21.3332 57.5H52.6666C55.495 57.5 56.9092 57.5 57.7879 56.6213C58.6666 55.7426 58.6666 54.3284 58.6666 51.5V48.8333H45.6666C43.3319 48.8333 42.1646 48.8333 41.281 48.361C40.5833 47.9881 40.0118 47.4166 39.6389 46.7189C39.1666 45.8353 39.1666 44.668 39.1666 42.3333C39.1666 39.9987 39.1666 38.8314 39.6389 37.9477C40.0118 37.25 40.5833 36.6786 41.281 36.3056C42.1646 35.8333 43.3319 35.8333 45.6666 35.8333H58.6666V24.5C58.6666 21.6716 58.6666 20.2574 57.7879 19.3787C56.9092 18.5 55.495 18.5 52.6666 18.5H21.3332C18.5048 18.5 17.0906 18.5 16.2119 19.3787ZM26.1666 28.3333C25.6143 28.3333 25.1666 28.781 25.1666 29.3333C25.1666 29.8856 25.6143 30.3333 26.1666 30.3333H32.6666C33.2189 30.3333 33.6666 29.8856 33.6666 29.3333C33.6666 28.781 33.2189 28.3333 32.6666 28.3333H26.1666Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8332 42.333H45.6666",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayChargeIcon);
export default __webpack_public_path__ + "static/media/payChargeIcon.ba2fcdbe0f9a7d47933e472da5f50c80.svg";
export { ForwardRef as ReactComponent };